"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteMarketSegment = void 0;
var QuoteType_1 = require("./QuoteType");
Object.defineProperty(exports, "QuoteMarketSegment", { enumerable: true, get: function () { return QuoteType_1.QuoteMarketSegment; } });
//# sourceMappingURL=index.js.map